import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

const Bar = styled.footer`
  margin-top: 60px; padding: 32px 20px; background: #0284c7; color:#fff; text-align:left;
`;
const Grid = styled.div`
  display:grid; grid-template-columns: repeat(3, 1fr); gap:16px; max-width:1100px; margin:0 auto;
  @media (max-width: 800px){ grid-template-columns: 1fr 1fr; }
  @media (max-width: 520px){ grid-template-columns: 1fr; }
`;
const Col = styled.div`display:flex; flex-direction:column; gap:8px;`;
const Title = styled.h4`margin:0 0 8px; font-size:16px; color:#fff;`;
const LinkA = styled.a`color:#fff; opacity:.95; text-decoration:none; &:hover{ text-decoration:underline; opacity:1; }`;

export default function Footer() {
  const { t } = useTranslation();
  const { lng = 'sr' } = useParams();
  const base = `#/${lng}`;
  return (
    <Bar>
      <Grid>
        <Col>
          <Title>{t('footer.contact_title', 'Kontakt')}</Title>
          <div>☎️ <LinkA href="tel:+381601234567">+381 60 123 4567</LinkA></div>
          <div>✉️ <LinkA href="mailto:info@movingco.rs">info@movingco.rs</LinkA></div>
          <div>🏢 Beograd, Srbija</div>
        </Col>
        <Col>
          <Title>{t('footer.quick_links', 'Brzi linkovi')}</Title>
          <LinkA href={`${base}`}>Početna</LinkA>
          <LinkA href={`${base}/quote`}>Ponuda</LinkA>
          <LinkA href={`${base}/blog`}>Blog</LinkA>
          <LinkA href={`${base}/contact`}>Kontakt</LinkA>
        </Col>
        <Col>
          <Title>{t('footer.hours', 'Radno vreme')}</Title>
          <div>{t('footer.hours_week', 'Pon–Pet: 08–18h')}</div>
          <div>{t('footer.hours_weekend', 'Sub: 09–14h; Ned: po potrebi')}</div>
        </Col>
      </Grid>
  <div style={{ marginTop:16, textAlign:'center', color:'rgba(255,255,255,.85)' }}>
        <small>{t('footer.rights', { year: new Date().getFullYear() })}</small>
      </div>
    </Bar>
  );
}
